/** Shared step keys for the kit-registration flow definition and runtime step resolution. */
export const KIT_REGISTRATION_FLOW_ID = 'kit-registration'
export const KIT_ID_STEP_KEY = 'kit-id'
export const ELIGIBILITY_QUESTIONNAIRE_STEP_KEY = 'eligibility-questionnaire'
export const CONSENT_AGREEMENT_STEP_KEY = 'consent-agreement'
export const PERSONAL_INFO_STEP_KEY = 'personal-info'
export const ADDRESS_INFO_STEP_KEY = 'address-info'
export const PRIMARY_CARE_PROVIDER_STEP_KEY = 'primary-care-provider'
export const SAMPLE_COLLECTION_INTRO_STEP_KEY = 'intro'

export const KIT_REGISTRATION_RUNTIME_STEP_KEYS = [
  ELIGIBILITY_QUESTIONNAIRE_STEP_KEY,
  ADDRESS_INFO_STEP_KEY,
  PRIMARY_CARE_PROVIDER_STEP_KEY,
  SAMPLE_COLLECTION_INTRO_STEP_KEY,
] as const

/**
 * The submittable form steps of kit registration. Direct URL access to any of
 * these steps must be blocked once registration is complete — they present forms
 * that would re-submit data for an already-registered kit. Does NOT include
 * `intro` or `shipping`, which are post-registration sample-collection steps.
 */
export const KIT_REGISTRATION_FORM_STEP_KEYS = [
  KIT_ID_STEP_KEY,
  ELIGIBILITY_QUESTIONNAIRE_STEP_KEY,
  CONSENT_AGREEMENT_STEP_KEY,
  PERSONAL_INFO_STEP_KEY,
  ADDRESS_INFO_STEP_KEY,
  PRIMARY_CARE_PROVIDER_STEP_KEY,
] as const
